import React from "react";
import { Box, Button, MenuItem, Stack, TextField, Typography } from "@mui/material";
import FeatherIcon from "feather-icons-react";
import { useTranslation } from "react-i18next";

import { ColumnDefinition } from "../../EmployeeDataDrawer";

interface MassEditToolbarProps {
  columns: ColumnDefinition[];
  massEditField: string;
  setMassEditField: React.Dispatch<React.SetStateAction<string>>;
  massEditValue: string;
  setMassEditValue: React.Dispatch<React.SetStateAction<string>>;
  selectedCount: number;
  filteredCount: number;
  onApply: () => void;
}

export const MassEditToolbar: React.FC<MassEditToolbarProps> = ({
  columns,
  massEditField,
  setMassEditField,
  massEditValue,
  setMassEditValue,
  selectedCount,
  filteredCount,
  onApply,
}) => {
  const { t } = useTranslation();

  return (
    <Box sx={{ px: 2, pb: 2 }}>
      <Typography variant="subtitle2" gutterBottom>
        {t("paygap.employeeData.massEdit.title")}
      </Typography>
      <Stack
        direction={{ xs: "column", md: "row" }}
        spacing={2}
        alignItems={{ xs: "stretch", md: "flex-end" }}
      >
        <TextField
          select
          label={t("paygap.employeeData.massEdit.field")}
          size="small"
          value={massEditField}
          onChange={(event): void => setMassEditField(event.target.value)}
          sx={{ minWidth: 180 }}
        >
          {columns
            .filter((column) => column.key !== "key")
            .map((column) => (
              <MenuItem key={column.key} value={column.key}>
                {column.label}
              </MenuItem>
            ))}
        </TextField>
        <TextField
          label={t("paygap.employeeData.massEdit.value")}
          size="small"
          value={massEditValue}
          onChange={(event): void => setMassEditValue(event.target.value)}
          sx={{ minWidth: 200 }}
        />
        <Button
          variant="contained"
          color="secondary"
          onClick={onApply}
          disabled={filteredCount === 0}
          startIcon={<FeatherIcon icon="edit-3" size={16} />}
        >
          {selectedCount > 0
            ? t("paygap.employeeData.massEdit.applySelected")
            : t("paygap.employeeData.massEdit.applyFiltered")}
        </Button>
      </Stack>
      <Typography variant="caption" color="textSecondary" sx={{ mt: 0.5 }}>
        {t("paygap.employeeData.massEdit.hint")}
      </Typography>
    </Box>
  );
};
